module.exports = {
  en: require('./en.json')
};



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/locale/index.js
// module id = 610
// module chunks = 0 2